
const FONTS_FAMILY = {
  regular: {
    body: 'Book',
    title: 'Bold',
  },
  medium: {
    body: 'Book',
    title: 'Bold',
  },
  bold: {
    body: 'Book',
    title: 'Bold',
  },
};

export default FONTS_FAMILY